// Vendors
import React from 'react';
// Components
import { IframeComponent } from 'components/iframe/iframe.component';
// Constants
import { KYC_METHOD_IFRAME_PROPS } from './constants/kyc-method.constants';
// Hooks
import { useKycMethodHook } from './hooks/kyc-method.hook';

const KycMethodView = (): React.JSX.Element => {
  const {
    handleManageReceivedDataFromKycWSEvent,
    handleManageReceivedDataFromKycIframeEvent,
    kycIframeUrl: src,
    selectedMethod,
    showLoader,
  } = useKycMethodHook();

  return (
    <IframeComponent
      {...{ ...KYC_METHOD_IFRAME_PROPS[selectedMethod], showLoader, src }}
      onReceiveDataHandler={handleManageReceivedDataFromKycWSEvent}
      onEventListen={handleManageReceivedDataFromKycIframeEvent}
    />
  );
};

export { KycMethodView };
